import { BankSettingsDialogComponent } from './bank-settings/dialogs/bank-settings-edit.component';
import { BankSettingsComponent } from './bank-settings/bank-settings.component';
import { FaqEditDialogComponent } from './faq-management/dialogs/faq-edit.component';
import { FaqManagementComponent } from './faq-management/faq-management.component';
import { BotStatusComponent } from './bot-status/bot-status.component';
import { BankReceiptsComponent } from './bank-receipts/bank-receipts.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MerchantBankComponent } from './merchant-banks/merchant-bank.component';
import { SettingsMaintainanceComponent } from './subcomponents/settings-maintainance/settings-maintainance.component';
import { ContactComponent } from './contacts/contact.component';
import { MerchantBankEditDialogComponent } from './merchant-banks/dialogs/merchant-bank-edit/merchant-bank-edit.component';
import { MerchantBankNewEditComponent } from './merchant-banks/dialogs/merchant-bank-new-edit/merchant-bank-new-edit.component';
import { BannerComponent } from './banners/banner.component';
import { LogoFaviconComponent } from './logo-favicon/logo-favicon.component';
import { BannerEditDialogComponent } from './banners/dialogs/banner-edit/banner-edit.component';
import { BankReceiptBrowserDialogComponent } from './bank-receipts/dialogs/bank-receipt-browser/bank-receipt-browser.component';
import { BankReceiptVoidDialogComponent } from './bank-receipts/dialogs/bank-receipt-void/bank-receipt-void.component';
import { BankReceiptRemarksDialogComponent } from './bank-receipts/dialogs/bank-receipt-remarks/bank-receipt-remarks.component';
import { BankTransactionFormDialogComponent } from './bank-transaction/dialogs/bank-transaction-form/bank-transaction-form.component';
import { BankTransactionComponent } from './bank-transaction/bank-transaction.component';
import { TransactionReconciliationComponent } from './transaction-reconciliation/transaction-reconciliation.component';
import { TermsConditionsEditDialogComponent } from './terms-conditions/dialogs/terms-conditions-edit.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { FaqSectionsComponent } from './faq-sections/faq-sections.component';
import { FaqSectionsEditDialogComponent } from './faq-sections/dialogs/faq-sections-edit.component';
import { LiveChatScriptComponent } from './live-chat-script/live-chat-script.component';
import { LiveChatScriptEditDialogComponent } from './live-chat-script/dialogs/live-chat-script-edit.component';
import { WhatsappNumberComponent } from './whatsapp-number/whatsapp-number.component';
import { WhatsappNumberEditDialogComponent } from './whatsapp-number/dialogs/whatsapp-number-edit/whatsapp-number-edit.component';
import { WhatsappBotComponent } from './whatsapp-bot/whatsapp-bot.component';
import { WhatsappBotEditDialogComponent } from './whatsapp-bot/dialogs/whatsapp-bot-edit/whatsapp-bot-edit.component';
import { WhatsappBotQRDialogComponent } from './whatsapp-bot/dialogs/whatsapp-bot-qr/whatsapp-bot-qr.component';
import { RegistrationPageComponent } from './registration-page/registration-page.component';
import { RegistrationPageEditComponent } from './registration-page/dialogs/registration-page-edit.component';
import { SectionSettingsComponent } from './footer-settings/section-settings/section-settings.component';
import { WebDisplayComponent } from './footer-settings/web-display/web-display.component';
import { WebDisplayEditDialogComponent } from './footer-settings/web-display/dialogs/web-display-edit.component';
import { MobileDisplayComponent } from './footer-settings/mobile-display/mobile-display.component';
import { FooterSectionEditDialogComponent } from './footer-settings/section-settings/footer-section/dialogs/footer-section-edit.component';
import { IconLibraryEditDialogComponent } from './footer-settings/section-settings/icon-library/dialogs/icon-library-edit.component';
import { QuickLinkEditDialogComponent } from './footer-settings/section-settings/quick-link/dialogs/quick-link-edit.component';
import { SeoSettingsComponent } from './seo-settings/seo-settings.component';
import { SeoSettingsEditComponent } from './seo-settings/dialogs/seo-settings-edit/seo-settings-edit.component';
import { RouteSettingsComponent } from './seo-settings/dialogs/route-settings/route-settings.component';
import { MetaTagSettingsComponent } from './seo-settings/dialogs/meta-tag-settings/meta-tag-settings.component';
import { MetaTagSettingsDuplicateComponent } from './seo-settings/dialogs/meta-tag-settings-duplicate/meta-tag-settings-duplicate.component';
import { BankMaintenanceHourComponent } from './bank-settings/dialogs/bank-maintenance-hour/bank-maintenance-hour.component';
import { MarqueesComponent } from './announcements/marquees/marquees.component';
import { DialogComponent } from './announcements/dialog/dialog.component';
import { UnSaveChangesGuard } from '@core/guards/unsavechanges.guard';
import { AboutUsComponent } from './about-us/about-us.component';
import { ResponsibleGamingComponent } from './responsible-gaming/responsible-gaming.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

import { DialogPreviewComponent } from './announcements/dialog/dialogs/dialog-preview.component';
import { DialogImportComponent } from './announcements/dialog/dialog-import/dialog-import.component';
import { BankReceiptEditComponent } from './bank-receipts/dialogs/bank-receipt-edit/bank-receipt-edit.component';
import { ReferralContentComponent } from './referral-content/referral-content.component';
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { MerchantBankWrapperComponent } from './merchant-banks/merchant-bank-wrapper/merchant-bank-wrapper.component';
import { PaymentGatewayBotComponent } from './payment-gateway-bot/payment-gateway-bot.component';
import { ViewTransactionReceiptComponent } from './bank-transaction/dialogs/view-transaction-receipt/view-transaction-receipt.component';
import { ImagePreviewDialogComponent } from './bank-transaction/dialogs/view-transaction-receipt/image-preview/image-preview.component';
import { AppPermissionKeys } from '@core/models/app-permissions.model';
import { ReconciliationJobCreateComponent } from './bot-status/dialogs/reconciliation-job-create.component';
import { PGReconciliationJobCreateComponent } from './payment-gateway-bot/dialogs/pg-reconciliation-job-create.component';
import { PaymentModeComponent } from './payment-mode/payment-mode.component';
import { PaymentModeDialogComponent } from './payment-mode/dialogs/payment-mode-edit.component';
import { PaymentModeImagePreviewComponent } from './payment-mode/dialogs/payment-mode-image-preview.component';
import { AIChatbotDialogComponent } from './live-chat-script/dialogs/ai-chatbot-dialog/ai-chatbot-dialog.component';
import { BotTransactionListComponent } from './bot-status/dialogs/bot-transaction-list/bot-transaction-list.component';

const routes: Routes = [
  {
    path: 'banners',
    component: BannerComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_banners_list }
  },
  {
    path: 'logo-favicon',
    component: LogoFaviconComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_logo_favicon_list }
  },
  {
    path: 'contacts',
    component: ContactComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions:  AppPermissionKeys.view_contacts_list }
  },
  {
    path: 'terms-and-conditions',
    component: TermsConditionsComponent,
    data: { permissions: AppPermissionKeys.view_tac_list }
  },
  {
    path: 'faq-management',
    component: FaqManagementComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_faq_list }
  },
  {
    path: 'faq-sections',
    component: FaqSectionsComponent,
    data: { permissions: AppPermissionKeys.view_faq_list }
  },
  {
    path: 'merchant-banks',
    component: MerchantBankWrapperComponent,
    data: { permissions: [AppPermissionKeys.view_bank_payment_gateway_list, AppPermissionKeys.view_crypto_merchant_account_list] }
  },
  {
    path: 'bank-transactions',
    component: BankTransactionComponent,
    data: { permissions: AppPermissionKeys.view_bank_transactions }
  },
  {
    path: 'bank-receipts',
    component: BankReceiptsComponent,
    data: { permissions: AppPermissionKeys.view_bank_receipts_list }
  },
  {
    path: 'bot-status',
    component: BotStatusComponent,
    data: { permissions: AppPermissionKeys.view_bank_bots_list }
  },
  {
    path: 'payment-gateway-bot',
    component: PaymentGatewayBotComponent,
    data: { permissions: AppPermissionKeys.view_payment_gateway_bots_list }
  },
  {
    path: 'transaction-reconciliation',
    component: TransactionReconciliationComponent,
    data: { permissions: AppPermissionKeys.view_transaction_recon }
  },
  {
    path: 'maintainance',
    component: SettingsMaintainanceComponent
  },
  {
    path: 'bank-settings',
    component: BankSettingsComponent,
    data: { permissions: AppPermissionKeys.view_bank_settings_list }
  },
  {
    path: 'whatsapp-number',
    component: WhatsappNumberComponent
  },
  {
    path: 'whatsapp-bot',
    component: WhatsappBotComponent
  },
  {
    path: 'js-plugin',
    component: LiveChatScriptComponent,
    canDeactivate: [UnSaveChangesGuard]
  },
  {
    path: 'registration-page',
    component: RegistrationPageComponent,
    data: { permissions: AppPermissionKeys.view_registration_page_list }
  },
  {
    path: 'section-settings',
    component: SectionSettingsComponent,
    data: { permissions: [AppPermissionKeys.view_footer_section_list, AppPermissionKeys.view_icon_library_list, AppPermissionKeys.view_quick_link_list] }
  },
  {
    path:'website-display',
    component: WebDisplayComponent,
    data: { permissions: AppPermissionKeys.view_website_display_list }
  },
  {
    path:'mobile-display',
    component: MobileDisplayComponent,
    data: { permissions: AppPermissionKeys.view_mobile_display_list }
  },
  {
    path: 'seo',
    component: SeoSettingsComponent,
    data: { permissions: AppPermissionKeys.view_seo_settings_list }
  },
  {
    path:'marquee',
    component: MarqueesComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_marquee_list }
  },
  {
    path:'dialog',
    component: DialogComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_dialog_list }
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_about_us_list }
  },
  {
    path: 'responsible-gaming',
    component: ResponsibleGamingComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_responsible_gaming_list }
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_privacy_policy_list }
  },
  {
    path:'referral-content',
    component: ReferralContentComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_referral_content_list }
  },
  {
    path:'menu-bar',
    component: MenuBarComponent,
    canDeactivate: [UnSaveChangesGuard],
    data: { permissions: AppPermissionKeys.view_menu_bar_list }
  },
  {
    path: 'payment-mode',
    component: PaymentModeComponent,
    data: { permissions: AppPermissionKeys.view_payment_mode_list }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    MerchantBankEditDialogComponent,
    MerchantBankNewEditComponent,
    BannerEditDialogComponent,
    BankReceiptVoidDialogComponent,
    BankReceiptBrowserDialogComponent,
    BankReceiptRemarksDialogComponent,
    BankTransactionFormDialogComponent,
    FaqEditDialogComponent,
    TermsConditionsEditDialogComponent,
    FaqSectionsEditDialogComponent,
    LiveChatScriptEditDialogComponent,
    BankSettingsDialogComponent,
    PaymentModeDialogComponent,
    WhatsappNumberEditDialogComponent,
    WhatsappBotEditDialogComponent,
    WhatsappBotQRDialogComponent,
    RegistrationPageEditComponent,
    FooterSectionEditDialogComponent,
    WebDisplayEditDialogComponent,
    IconLibraryEditDialogComponent,
    QuickLinkEditDialogComponent,
    SeoSettingsEditComponent,
    RouteSettingsComponent,
    MetaTagSettingsComponent,
    MetaTagSettingsDuplicateComponent,
    BankMaintenanceHourComponent,
    AboutUsComponent,
    PrivacyPolicyComponent,
    ResponsibleGamingComponent,
    DialogPreviewComponent,
    DialogImportComponent,
    BankReceiptEditComponent,
    ViewTransactionReceiptComponent,
    ImagePreviewDialogComponent,
    ReconciliationJobCreateComponent,
    PGReconciliationJobCreateComponent,
    PaymentModeImagePreviewComponent,
    AIChatbotDialogComponent,
    BotTransactionListComponent
  ]
})
export class SettingsRoutingModule { }
